import { lightTheme } from "styles/theme";
import { ColorProp, getColorFromTheme } from "styles/themes";

export function resolveColor(color: ColorProp | undefined, defaultValue: ColorProp): string {
  return getColorFromTheme(color ?? defaultValue, lightTheme);
}

export function applyColorOverrides(
  svgProps: Record<string, unknown>,
  resolvedColor: string,
  inheritedFill: string | undefined,
): Record<string, string> {
  const overrides: Record<string, string> = {};

  if (svgProps.fill === "currentColor") {
    overrides.fill = resolvedColor;
  } else if (svgProps.fill === "inherit" && inheritedFill !== undefined) {
    overrides.fill = inheritedFill;
  } else if (!("fill" in svgProps) && inheritedFill !== undefined) {
    overrides.fill = inheritedFill;
  }

  if (svgProps.stroke === "currentColor" || svgProps.stroke === "inherit") {
    overrides.stroke = resolvedColor;
  }

  return overrides;
}
